/* Craftybella · shoppable reel carousel.
   The whole point of this file: the number of DOM nodes and <video> elements is
   fixed no matter how many reels exist. Seven cards are created once and
   recycled as you move, and exactly one video ever holds a src. Ten reels and
   five hundred reels cost the browser the same. */
(function () {
  'use strict';

  var RADIUS = 3;                 /* cards either side of centre */
  var SETTLE = 220;               /* ms of stillness before we mount a video */
  var DRAG_MIN = 40;              /* px before a drag counts as a swipe */
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function mod(n, m) { return ((n % m) + m) % m; }
  function el(tag, cls) { var e = document.createElement(tag); if (cls) e.className = cls; return e; }

  var ICON = {
    play: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z" fill="currentColor"/></svg>',
    ig: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.2c3.2 0 3.6 0 4.9.07 3.3.15 4.8 1.7 5 5 .06 1.3.07 1.7.07 4.9s0 3.6-.07 4.9c-.15 3.3-1.7 4.8-5 5-1.3.06-1.7.07-4.9.07s-3.6 0-4.9-.07c-3.3-.15-4.8-1.7-5-5C2.03 15.6 2 15.2 2 12s0-3.6.07-4.9c.15-3.3 1.7-4.8 5-5C8.4 2.2 8.8 2.2 12 2.2zm0 3.1a6.7 6.7 0 100 13.4 6.7 6.7 0 000-13.4zm0 11a4.3 4.3 0 110-8.6 4.3 4.3 0 010 8.6zm6.9-11.2a1.57 1.57 0 11-3.13 0 1.57 1.57 0 013.13 0z" fill="currentColor"/></svg>',
    on: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M11 5L6 9H3v6h3l5 4V5z" fill="currentColor"/><path d="M15.5 8.5a5 5 0 010 7M18 6a8.5 8.5 0 010 12" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
    off: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M11 5L6 9H3v6h3l5 4V5z" fill="currentColor"/><path d="M16 9.5l5 5m0-5l-5 5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>'
  };

  function igEmbed(url) {
    var m = String(url || '').match(/instagram\.com\/(?:reels?|p|tv)\/([A-Za-z0-9_-]+)/);
    return m ? 'https://www.instagram.com/reel/' + m[1] + '/embed/' : null;
  }

  function Carousel(root) {
    var self = this;
    this.root = root;
    this.track = root.querySelector('[data-track]');
    this.stage = root.querySelector('[data-stage]');
    this.capEl = root.querySelector('[data-caption]');
    this.dotsEl = root.querySelector('[data-dots]');
    this.cta = root.getAttribute('data-cta') || 'Shop now';
    this.autoplay = root.getAttribute('data-autoplay') === 'true' && !reduced;
    this.visDesktop = (parseInt(root.getAttribute('data-slots-dk'), 10) - 1) / 2 || 2;

    try {
      this.data = JSON.parse(root.querySelector('script[data-reels]').textContent) || [];
    } catch (e) { this.data = []; }
    this.data = this.data.filter(function (r) { return r && (r.lo || r.ig); })
                         .sort(function (a, b) { return (a.o || 0) - (b.o || 0); });
    this.n = this.data.length;
    if (!this.n) return;

    this.i = 0;
    this.muted = true;
    this.video = null;
    this.warm = null;
    this.timer = null;
    this.visible = true;

    this.buildSlots();
    this.buildDots();
    this.layout(true);
    this.bindEvents();
    this.scheduleMount();

    this.viewer = new Viewer(root, this);

    /* stop everything the moment the section leaves the screen */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        self.visible = entries[0].isIntersecting;
        if (!self.visible) self.pause(); else self.scheduleMount();
      }, { threshold: 0.25 }).observe(root);
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) self.pause(); else if (self.visible) self.scheduleMount();
    });
  }

  Carousel.prototype.buildSlots = function () {
    this.slots = [];
    for (var off = -RADIUS; off <= RADIUS; off++) {
      var s = el('div', 'cb-rl__slot');
      s.dataset.off = String(off);
      s.setAttribute('role', 'button');
      s.tabIndex = -1;
      s.innerHTML =
        '<div class="cb-rl__ph"></div>' +
        '<img alt="" loading="lazy" decoding="async">' +
        '<div class="cb-rl__play"><span>' + ICON.play + '</span></div>' +
        '<span class="cb-rl__shop"></span>';
      this.track.appendChild(s);
      this.slots.push(s);
    }
  };

  Carousel.prototype.buildDots = function () {
    if (!this.dotsEl) return;
    var self = this;
    if (this.n > 12) {                       /* 100 dots helps nobody */
      this.counter = el('span', 'cb-rl__count');
      this.counter.style.cssText = 'font-size:12px;color:inherit;opacity:.65;letter-spacing:.04em';
      this.dotsEl.appendChild(this.counter);
      return;
    }
    this.dots = [];
    for (var k = 0; k < this.n; k++) {
      (function (k) {
        var d = el('button', 'cb-rl__dot');
        d.type = 'button';
        d.setAttribute('aria-label', 'Go to reel ' + (k + 1));
        d.addEventListener('click', function () { self.jump(k); });
        self.dotsEl.appendChild(d);
        self.dots.push(d);
      })(k);
    }
  };

  /* Put the right reel in every slot and show the right ones for this width. */
  Carousel.prototype.layout = function (initial) {
    var wide = window.innerWidth > 767;
    var vis = wide ? this.visDesktop : 1;
    vis = Math.min(vis, Math.floor((this.n - 1) / 2));   /* no duplicate cards */
    for (var k = 0; k < this.slots.length; k++) {
      var s = this.slots[k], off = parseInt(s.dataset.off, 10);
      if (initial) this.bind(s, mod(this.i + off, this.n));
      if (Math.abs(off) > vis) { s.style.opacity = '0'; s.style.pointerEvents = 'none'; }
      else { s.style.removeProperty('opacity'); s.style.removeProperty('pointer-events'); }
      s.tabIndex = off === 0 ? 0 : -1;
    }
    this.paint();
  };

  Carousel.prototype.bind = function (slot, idx) {
    var r = this.data[idx];
    slot.dataset.idx = String(idx);
    var img = slot.querySelector('img');
    if (r.ps) { img.src = r.ps; img.style.display = ''; } else { img.removeAttribute('src'); img.style.display = 'none'; }
    img.alt = r.t || 'Reel';
    slot.setAttribute('aria-label', (r.t || 'Reel ' + (idx + 1)) + ' — open and shop');
    var mark = slot.querySelector('.cb-rl__mark');
    if (r.ig && !r.lo) {
      if (!mark) { mark = el('span', 'cb-rl__mark'); mark.innerHTML = ICON.ig; slot.appendChild(mark); }
    } else if (mark) { mark.remove(); }
    var shop = slot.querySelector('.cb-rl__shop');
    shop.textContent = (r.p && r.p.length) ? this.cta : '';
    shop.style.display = (r.p && r.p.length) ? '' : 'none';
  };

  Carousel.prototype.paint = function () {
    var r = this.data[this.i];
    if (this.capEl) this.capEl.textContent = r.t || '';
    if (this.dots) for (var k = 0; k < this.dots.length; k++) {
      this.dots[k].setAttribute('aria-current', k === this.i ? 'true' : 'false');
    }
    if (this.counter) this.counter.textContent = (this.i + 1) + ' / ' + this.n;
  };

  Carousel.prototype.go = function (dir) {
    if (!this.n || !dir) return;
    this.unmount();
    var edge = dir > 0 ? -RADIUS : RADIUS;
    var wrap = null, k, s, off;
    for (k = 0; k < this.slots.length; k++) {
      s = this.slots[k];
      off = parseInt(s.dataset.off, 10);
      if (off === edge) wrap = s;
      s.dataset.off = String(off - dir);
    }
    this.i = mod(this.i + dir, this.n);
    if (wrap) {
      wrap.classList.add('is-parked');            /* teleport, do not animate */
      wrap.dataset.off = String(dir > 0 ? RADIUS : -RADIUS);
      this.bind(wrap, mod(this.i + (dir > 0 ? RADIUS : -RADIUS), this.n));
      void wrap.offsetWidth;
      wrap.classList.remove('is-parked');
    }
    this.layout(false);
    this.scheduleMount();
  };

  Carousel.prototype.jump = function (target) {
    var d = target - this.i;
    if (!d) return;
    var half = Math.floor(this.n / 2);
    if (d > half) d -= this.n; else if (d < -half) d += this.n;
    var step = d > 0 ? 1 : -1, hops = Math.min(Math.abs(d), RADIUS + 1), self = this;
    /* long jumps walk a few frames so the motion still reads as a slide */
    (function hop(remaining, total) {
      self.go(step);
      if (--remaining > 0) setTimeout(function () { hop(remaining, total); }, 90);
      else if (self.i !== target) { self.i = target; self.layout(true); self.scheduleMount(); }
    })(hops, hops);
  };

  Carousel.prototype.centre = function () {
    for (var k = 0; k < this.slots.length; k++) if (this.slots[k].dataset.off === '0') return this.slots[k];
    return null;
  };

  Carousel.prototype.unmount = function () {
    if (!this.video) return;
    try { this.video.pause(); this.video.removeAttribute('src'); this.video.load(); } catch (e) {}
    if (this.video.parentNode) this.video.parentNode.removeChild(this.video);
    var c = this.centre();
    if (c) c.classList.remove('is-playing');
    this.video = null;
  };

  Carousel.prototype.pause = function () {
    clearTimeout(this.timer);
    if (this.video) { try { this.video.pause(); } catch (e) {} }
  };

  Carousel.prototype.scheduleMount = function () {
    var self = this;
    clearTimeout(this.timer);
    this.timer = setTimeout(function () { self.mount(); }, SETTLE);
  };

  Carousel.prototype.mount = function () {
    if (!this.visible || document.hidden || this.locked) return;
    var slot = this.centre();
    if (!slot) return;
    var r = this.data[this.i];
    if (!r.lo) return;                              /* Instagram-only: poster stays */
    if (this.video && this.video.dataset.idx === String(this.i)) { this.play(); return; }
    this.unmount();

    var v = document.createElement('video');
    v.dataset.idx = String(this.i);
    v.muted = this.muted; v.loop = true; v.playsInline = true;
    v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
    v.preload = 'auto';
    if (r.ps) v.poster = r.ps;
    v.src = r.lo;
    var self = this;
    v.addEventListener('playing', function () { slot.classList.add('is-playing'); });
    v.addEventListener('error', function () { self.unmount(); });
    slot.appendChild(v);
    this.video = v;

    if (!slot.querySelector('.cb-rl__mute')) {
      var b = el('button', 'cb-rl__mute');
      b.type = 'button';
      b.innerHTML = ICON.off;
      b.setAttribute('aria-label', 'Unmute');
      b.addEventListener('click', function (ev) {
        ev.stopPropagation();
        self.muted = !self.muted;
        if (self.video) self.video.muted = self.muted;
        b.innerHTML = self.muted ? ICON.off : ICON.on;
        b.setAttribute('aria-label', self.muted ? 'Unmute' : 'Mute');
      });
      slot.appendChild(b);
    }

    this.play();
    this.preloadNext();
  };

  Carousel.prototype.play = function () {
    if (!this.autoplay || !this.video) return;
    var p = this.video.play();
    if (p && p.catch) p.catch(function () { /* browser refused; poster stays */ });
  };

  /* One detached element pulls just the headers of the next clip, so moving on
     feels instant without downloading anything we may never show. */
  Carousel.prototype.preloadNext = function () {
    var nxt = this.data[mod(this.i + 1, this.n)];
    if (!nxt || !nxt.lo) return;
    if (this.warm && this.warm.src === nxt.lo) return;
    if (this.warm) { try { this.warm.removeAttribute('src'); this.warm.load(); } catch (e) {} }
    var w = document.createElement('video');
    w.preload = 'metadata'; w.muted = true; w.src = nxt.lo;
    this.warm = w;
  };

  Carousel.prototype.bindEvents = function () {
    var self = this, sx = 0, sy = 0, dx = 0, dragging = false, decided = false;

    var prev = this.root.querySelector('[data-prev]');
    var next = this.root.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { self.go(-1); });
    if (next) next.addEventListener('click', function () { self.go(1); });

    this.stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); self.go(-1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); self.go(1); }
      else if (e.key === 'Enter' || e.key === ' ') {
        if (document.activeElement && document.activeElement.dataset.off === '0') {
          e.preventDefault(); self.viewer.open(self.i);
        }
      }
    });

    this.track.addEventListener('click', function (e) {
      if (self.locked) return;                      /* the viewer is open */
      if (Math.abs(dx) > 6) return;                 /* that was a drag */
      var slot = e.target.closest('.cb-rl__slot');
      if (!slot) return;
      var off = parseInt(slot.dataset.off, 10);
      if (off === 0) self.viewer.open(self.i);
      else self.go(off > 0 ? 1 : -1);
    });

    function down(e) {
      if (e.button != null && e.button !== 0) return;
      dragging = true; decided = false; dx = 0;
      sx = e.clientX; sy = e.clientY;
      self.track.style.transition = 'none';
    }
    function move(e) {
      if (!dragging) return;
      dx = e.clientX - sx;
      if (!decided) {
        if (Math.abs(e.clientY - sy) > Math.abs(dx) + 6) { dragging = false; reset(); return; }
        if (Math.abs(dx) > 6) decided = true;
      }
      if (decided) self.track.style.transform = 'translate3d(' + (dx * 0.32) + 'px,0,0)';
    }
    function reset() { self.track.style.transition = ''; self.track.style.transform = ''; }
    function up() {
      if (!dragging) return;
      dragging = false;
      reset();
      if (Math.abs(dx) > DRAG_MIN) self.go(dx < 0 ? 1 : -1);
      setTimeout(function () { dx = 0; }, 0);
    }

    this.stage.addEventListener('pointerdown', down);
    window.addEventListener('pointermove', move, { passive: true });
    window.addEventListener('pointerup', up);
    window.addEventListener('pointercancel', up);

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { self.layout(false); }, 150);
    });
  };

  /* ------------------------------------------------------------------ */
  function Viewer(root, car) {
    this.car = car;
    var node = root.nextElementSibling;
    if (!node || !node.hasAttribute || !node.hasAttribute('data-viewer')) {
      node = (root.parentNode || document).querySelector('[data-viewer]');
    }
    if (!node) return;
    this.node = node;

    /* The overlay has to sit on <body>.

       Inside the section it is a descendant of an element the homepage
       stylesheet gives content-visibility:auto, and that implies contain:paint
       -- which makes the section a containing block for position:fixed
       children. So the viewer stopped covering the viewport and laid itself out
       INSIDE the section instead: the rest of the page showed below it, the
       close button was there but the overlay never went anywhere, and on iOS
       the video surface stopped painting while its audio carried on.

       Moving the node out from under that ancestor fixes the positioning, the
       black video and the stuck close in one go. */
    var key = node.getAttribute('data-viewer') || '';
    if (key) {
      var olds = document.querySelectorAll('body > [data-viewer="' + key + '"]');
      for (var oi = 0; oi < olds.length; oi++) {
        if (olds[oi] !== node && olds[oi].parentNode) olds[oi].parentNode.removeChild(olds[oi]);
      }
    }
    if (node.parentNode !== document.body) document.body.appendChild(node);

    this.media = node.querySelector('[data-vmedia]');
    this.title = node.querySelector('[data-vtitle]');
    this.prods = node.querySelector('[data-vprods]');
    var self = this;
    node.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('[data-close]')) { e.preventDefault(); self.close(); }
    });
    node.querySelector('[data-vprev]').addEventListener('click', function () { self.step(-1); });
    node.querySelector('[data-vnext]').addEventListener('click', function () { self.step(1); });
    document.addEventListener('keydown', function (e) {
      if (self.node.hidden) return;
      if (e.key === 'Escape') self.close();
      else if (e.key === 'ArrowLeft') self.step(-1);
      else if (e.key === 'ArrowRight') self.step(1);
      else if (e.key === 'Tab') self.trap(e);
    });
  }

  Viewer.prototype.open = function (i) {
    if (!this.node) return;
    this.i = i;
    this.opener = document.activeElement;
    this.car.locked = true;
    this.car.pause();
    this.car.unmount();
    this.node.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    this.render();
    var x = this.node.querySelector('.cb-rv__x');
    if (x) x.focus();
  };

  Viewer.prototype.close = function () {
    if (!this.node || this.node.hidden) return;
    /* Hide BEFORE tearing anything down. If a later step throws, the overlay is
       already gone -- a half-failed teardown must never leave it stuck open. */
    this.node.hidden = true;
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    try { this.clearMedia(); } catch (e) {}
    try { if (this.opener && this.opener.focus) this.opener.focus(); } catch (e) {}
    this.car.locked = false;
    this.car.scheduleMount();
  };

  Viewer.prototype.step = function (d) {
    this.i = mod(this.i + d, this.car.n);
    this.car.jump(this.i);
    this.render();
  };

  Viewer.prototype.clearMedia = function () {
    if (!this.media) return;
    var v = this.media.querySelector('video');
    if (v) { try { v.pause(); v.removeAttribute('src'); v.load(); } catch (e) {} }
    this.media.innerHTML = '';
  };

  Viewer.prototype.render = function () {
    var r = this.car.data[this.i];
    this.clearMedia();
    this.title.textContent = r.t || '';

    if (r.lo) {
      var v = document.createElement('video');
      v.controls = true; v.loop = true; v.playsInline = true;
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
      v.setAttribute('controlslist', 'nodownload');
      v.setAttribute('disablepictureinpicture', '');
      v.muted = false;
      v.preload = 'auto';
      if (r.ps) v.poster = r.ps;
      v.src = r.hi || r.lo;
      this.media.appendChild(v);
      var p = v.play();
      if (p && p.catch) p.catch(function () { v.muted = true; v.play().catch(function () {}); });
    } else if (r.ig) {
      var embed = igEmbed(r.ig);
      if (embed) {
        var f = document.createElement('iframe');
        f.src = embed;
        f.loading = 'lazy';
        f.allow = 'encrypted-media; picture-in-picture';
        f.setAttribute('allowfullscreen', '');
        f.title = r.t || 'Instagram reel';
        this.media.appendChild(f);
      }
    }

    var html = '';
    var list = r.p || [];
    for (var k = 0; k < list.length; k++) {
      var pr = list[k];
      html += '<a class="cb-rv__card" href="' + pr.u + '">' +
              (pr.i ? '<img src="' + pr.i + '" alt="" loading="lazy" decoding="async">' : '<span class="cb-rv__card-ph"></span>') +
              '<span><span class="cb-rv__nm">' + pr.t + '</span>' +
              '<span class="cb-rv__pr">' + (pr.cp ? '<del>' + pr.cp + '</del>' : '') + pr.pr + '</span></span>' +
              (pr.a ? '<span class="cb-rv__go">' + this.car.cta + '</span>'
                    : '<span class="cb-rv__so">Sold out</span>') +
              '</a>';
    }
    if (!list.length) html = '<p class="cb-rv__note">No products linked to this reel yet.</p>';
    if (!r.lo && r.ig) {
      html += '<p class="cb-rv__note">Instagram controls playback in this embed, so it will not autoplay. ' +
              '<a href="' + r.ig + '" target="_blank" rel="noopener">Open on Instagram</a></p>';
    }
    this.prods.innerHTML = html;
  };

  Viewer.prototype.trap = function (e) {
    var f = this.node.querySelectorAll('button, a[href], video, iframe');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  };

  function boot() {
    document.querySelectorAll('[data-cb-reels]').forEach(function (root) {
      if (root.__cbReels) return;
      root.__cbReels = true;
      try { new Carousel(root); } catch (e) { /* never take the page down */ }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
